

export class SOPutProduct {

  constructor(
    public uid: string,
    public name: string = null,
    public sku: string = null,
    public exRef: string = null,
    public active: boolean = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutProduct(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'sku' in params ? params.sku : null,
      'exRef' in params ? params.exRef : null,
      'active' in params ? params.active : null,
    );
  }
}
